import App from './App.svelte';
import './i18n';
import { accessTokenRefresh, CheckLocalStorage } from './tokenFunction';
import { push } from 'svelte-spa-router';
import { access_token } from './components/stores';
import { get } from 'svelte/store';
import * as Sentry from "@sentry/svelte";
import { BrowserTracing } from "@sentry/tracing";
import Logger from './Logger';
import { info_client } from './components/stores';
const time = UPDATE_TOKEN_TIME ? UPDATE_TOKEN_TIME : 60;
if (!DEBUG) {
    if (IS_ENABLE_SENTRY) {
        Sentry.init({
            dsn: SENTRY_DSN,
            environment: 'frontend-production',
            integrations: [new BrowserTracing()],
            tracesSampleRate: 1.0,
        });
    }
}
async function getApp() {
    try {
        if (document.location.hash.indexOf('get-access-token') === -1) {
            await CheckLocalStorage();
            await accessTokenRefresh();
            if (IS_ENABLE_SENTRY) {
                new Logger(get(info_client));
            }
            // Выводим access_token при разработке 
            // для удобства тестирования
            if (DEBUG) {
                console.log(get(access_token));
            }
        }
        setInterval(() => accessTokenRefresh(), (time * 30) * 1000);
    }
    catch (err) {
        console.log(err);
        push('/token_error/');
    }
    return new App({
        target: document.body,
        props: {}
    });
}
export default getApp();
